/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Ad_Render_TtsInputs */

const en_shortcut_keys_desc_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Render Audio Description (DV) text to audio.`)
};

const fr_shortcut_keys_desc_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendre le texte de description audio (DV) en audio.`)
};

const de_shortcut_keys_desc_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibungstext (DV) in Audio umwandeln.`)
};

const it_shortcut_keys_desc_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma il testo della descrizione audio (DV) in audio.`)
};

const ru_shortcut_keys_desc_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразование текста описания звука (DV) в аудио.`)
};

const es_shortcut_keys_desc_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir texto de descripción de audio (DV) a audio.`)
};

const zh_cn2_shortcut_keys_desc_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将音频描述 (DV) 文本渲染为音频。`)
};

const ja_shortcut_keys_desc_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ説明 (DV) テキストをオーディオにレンダリングします。`)
};

const hi_shortcut_keys_desc_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण (डीवी) टेक्स्ट को ऑडियो में रूपांतरित करें।`)
};

const pt_pt2_shortcut_keys_desc_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter texto de audiodescrição (DV) em áudio.`)
};

/**
* | output |
* | --- |
* | "Render Audio Description (DV) text to audio." |
*
* @param {Shortcut_Keys_Desc_Ad_Render_TtsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_ad_render_tts = /** @type {((inputs?: Shortcut_Keys_Desc_Ad_Render_TtsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Ad_Render_TtsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_ad_render_tts(inputs)
	if (locale === "de") return de_shortcut_keys_desc_ad_render_tts(inputs)
	if (locale === "it") return it_shortcut_keys_desc_ad_render_tts(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_ad_render_tts(inputs)
	if (locale === "es") return es_shortcut_keys_desc_ad_render_tts(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_ad_render_tts(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_ad_render_tts(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_ad_render_tts(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_ad_render_tts(inputs)
	return en_shortcut_keys_desc_ad_render_tts(inputs)
});